import 'utils/extensions';

import * as seazit from './seazit';

window.apps.seazit = seazit;
